import React, { useState, useEffect } from "react";
import axios from "axios";
import { Dimmer } from 'semantic-ui-react';
import { Mensaje } from '../mensajes';



function ReportesConfig(props) {
    let op = require('../../../public/modulos/datos');
    const [reporteOption, setReporteOption] = useState("HOJA");
    const [notaOption, setNotaOption] = useState("HOJA");
    const [activate, setActivate] = useState(false);
     const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
 
 
    const token = sessionStorage.getItem("jwtToken");


    const guardarConfiguracion = async () => {
        try {
            setActivate(true);
            const endpoint = `${op.conexion}/api/comun/updateconfig`;
            
            const response = await axios.post(endpoint, {
                tiporeppedido: reporteOption,
                tiporepnotaentrega: notaOption
            }, {
                headers: { 'x-access-token': token }
            });

            if (response.status === 200) {
                setMensaje({
                    mostrar: true,
                    titulo: "Éxito",
                    texto: "Configuración guardada correctamente",
                    icono: "exito",
                });
                seleccionarRegistro()
            }
        } catch (error) {
            let mensaje = error.response.data.message || "Error de conexión";
            setMensaje({
                mostrar: true,
                titulo: "Error",
                texto: mensaje,
                icono: "error",
            });
        } finally {
            setActivate(false);
        }
    };

    const seleccionarRegistro = () => {
        const campos = "*";
        const nomtab = "configsistema";
    
        const endpoint = `${op.conexion
          }/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=idconfig&id=1`;
    
        setActivate(true);
        axios
          .get(endpoint, {
            headers: {
              "x-access-token": `${token}`,
            },
          })
          .then(function (response) {
            if (response.status === 200) {
          console.log(response.data)
            setReporteOption(response.data.tiporeppedido)
          setNotaOption(response.data.tiporepnotaentrega)
          sessionStorage.setItem("tiporeppedido", JSON.stringify(response.data.tiporeppedido))
          sessionStorage.setItem("tiporepnotaentrega", JSON.stringify(response.data.tiporepnotaentrega))
                
            }
            setActivate(false);
          })
          .catch(function (error) {
            setActivate(false);
            console.log(error);
            setMensaje({
              mostrar: true,
              titulo: "Error",
              texto: error.response.data.message,
              icono: "error",
            });
          });
      };

        useEffect(() => {
            seleccionarRegistro();
         
        }, []);
    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-12 mx-auto row px-0">
                    <Dimmer active={activate} />
                                   <Mensaje mensaje={mensaje}
                                       onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />

                    <div className="card shadow-sm mt-4 px-0">
                        <div className="card-header azulGradiant text-white">
                            <h2 className="h5 mb-0 text-center">Configuración de Formatos de Impresión</h2>
                        </div>

                        <div className="card-body">
                            {/* Sección Reporte */}
                            <div className="mb-1 row align-items-center">
                                <h3 className="h6 col-md-3 fw-bold mb-0">Formato Reporte Pedido</h3>

                                <div className="form-check col-md-4">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        id="reporteFull"
                                        name="reporteOption"
                                        value="HOJA"
                                        checked={reporteOption.toString() === "HOJA"}
                                        onChange={(e) => setReporteOption(e.target.value)}
                                    />
                                    <label className="form-check-label" htmlFor="reporteFull">
                                        Hoja Completa
                                    </label>
                                </div>

                                <div className="form-check col-md-4">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        id="reporteHalf"
                                        name="reporteOption"
                                        value="MEDIA"
                                        checked={reporteOption.toString() === "MEDIA"}
                                        onChange={(e) => setReporteOption(e.target.value)}
                                    />
                                    <label className="form-check-label" htmlFor="reporteHalf">
                                        Media Hoja
                                    </label>
                                </div>
                            </div>

                            <hr className="my-3" />

                            {/* Sección Nota de Entrega */}
                            <div className="row align-items-center">
                                <h3 className="h6 fw-bold mb-0 col-md-3">Formato Nota de Entrega</h3>

                                <div className="form-check col-md-4">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        id="notaFull"
                                        name="notaOption"
                                        value="HOJA"
                                        checked={notaOption === "HOJA"}
                                        onChange={(e) => setNotaOption(e.target.value)}
                                    />
                                    <label className="form-check-label" htmlFor="notaFull">
                                        Hoja Completa
                                    </label>
                                </div>

                                <div className="form-check col-md-4">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        id="notaHalf"
                                        name="notaOption"
                                        value="MEDIA"
                                        checked={notaOption === "MEDIA"}
                                        onChange={(e) => setNotaOption(e.target.value)}
                                    />
                                    <label className="form-check-label" htmlFor="notaHalf">
                                        Media Hoja
                                    </label>
                                </div>
                            </div>

                            {/* Botón de Guardar */}
                            <div className="row mt-4">
                                <div className="col-md-12 text-end">
                                    <button
                                        className="btn btn-primary"
                                        onClick={guardarConfiguracion}
                                        disabled={activate}
                                    >
                                        {activate ? (
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        ) : (
                                            "Guardar Cambios"
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ReportesConfig;


// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/reportesConfig.js